// extracted by mini-css-extract-plugin
export default {"terms":"TermsOfService_terms__j+2X-","title":"TermsOfService_title__cB8vP","updated":"TermsOfService_updated__rV8lg","body":"TermsOfService_body__1Y0Xt"};